import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, rydeColors } from "@ryde/theme";

export const HeaderPopoverWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "header-popover-wrapper",
})`
  h2 {
    color: black;
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 10px;
  }
  svg {
    cursor: pointer;
    fill: ${rydeColors.grey};
  }
  .groupByTitle {
    font-size: 12px;
    font-weight: 600;
    margin-inline-end: 10px;
  }
  .header_text {
    font-size: 12px;
    margin-bottom: 15px;
    color: ${blueGreyMui._600};
    width: 140px;
  }
  .controls_wrapper {
    width: 140px;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    overflow: hidden;
  }
`;

export const GroupByContainerStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "group-by-container-popover",
})`
  display: flex;
  align-items: center;
`;
